import http from "@/services/http";

/**
 * Lista os tratamentos complementares do paciente (patient_complementary_treatments).
 * @param {number|string} patientId
 * @returns {Promise<object[]>}
 */
export async function getTreatmentsByPatient(patientId) {
  const { data } = await http.get(
    `/api/patient-complementary-treatments/get-by-patient/${patientId}`,
  );
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Catálogo de tratamentos complementares (referência) — alimenta o picker.
 * @returns {Promise<Array<{id:number, name:string, snomed_code:string|null}>>}
 */
export async function getTreatmentCatalog() {
  const { data } = await http.get("/api/complementary-treatment-catalog");
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Adiciona um ou vários tratamentos de uma vez.
 * @param {number|string} patientId
 * @param {object[]} treatments `[{ treatment, complementary_treatment_catalog_id?, notes? }]`
 */
export function createTreatments(patientId, treatments) {
  return http.post("/api/patient-complementary-treatments/create", {
    patient_id: patientId,
    treatments: treatments.map((t) => ({
      treatment: t.treatment,
      complementary_treatment_catalog_id: t.complementary_treatment_catalog_id || null,
      notes: t.notes || null,
    })),
  });
}

/**
 * Remove um tratamento (soft delete).
 * @param {number} id
 */
export function deleteTreatment(id) {
  return http.delete(`/api/patient-complementary-treatments/delete/${id}`);
}
